import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, resolveComponent as _resolveComponent, createBlock as _createBlock, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createSlots as _createSlots, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/subCircle.svg'


const _withScopeId = n => (_pushScopeId("data-v-d520e438"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "tw-text-[13px] tw-text-[#231F20] tw-whitespace-nowrap tw-min-h-[20px]"
}
const _hoisted_2 = {
  key: 0,
  class: "tw-text-[13px] tw-text-[#231F20] tw-whitespace-nowrap tw-min-h-[20px]"
}
const _hoisted_3 = { class: "tw-flex tw-gap-[10px]" }
const _hoisted_4 = {
  key: 0,
  class: "tw-text-[13px] tw-text-[#231F20] tw-min-h-[20px]"
}
const _hoisted_5 = ["onUpdate:modelValue", "onKeyup", "onBlur"]
const _hoisted_6 = {
  key: 0,
  class: "tw-text-[13px] tw-text-[#231F20] tw-whitespace-nowrap w-mw-[100px]"
}
const _hoisted_7 = {
  key: 0,
  class: "tw-text-[13px] tw-text-[#231F20] tw-whitespace-nowrap tw-min-h-[20px] w-mw-[100px]"
}
const _hoisted_8 = { class: "tw-flex tw-gap-[10px]" }
const _hoisted_9 = {
  key: 0,
  class: "tw-text-[13px] tw-text-[#231F20] tw-min-h-[20px]"
}
const _hoisted_10 = ["onUpdate:modelValue", "onKeyup", "onBlur"]
const _hoisted_11 = ["onClick"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "tw-w-6 tw-h-6",
  src: _imports_0,
  alt: "sub"
}, null, -1))
const _hoisted_13 = [
  _hoisted_12
]

import { getComponentUiText } from "@/utils/utilities";
import CustomTable, {
  CustomTableColumn,
} from "@/components/common/customTable.vue";
import { computed, onMounted, ref, watch, watchEffect } from "vue";
import BaseDropDown from "@/components/common/form/baseDropDown.vue";
import {
  CHECKLIST_ICON_VALUE_WITH_BG_COLOR,
  CHECKLIST_ICON_VALUE_WITH_COLOR,
  CHECKLIST_IMPACT_VALUE_WITH_BG_COLOR,
  CHECKLIST_IMPACT_VALUE_WITH_COLOR,
  SCORE_TYPE,
} from "@/utils/constants";
import { IDropDownData } from "@/interfaces/common/IDropDown";
import BaseDropDownItem from "@/components/common/form/baseDropDownItem.vue";
import { ICyberReportIncidents } from "@/interfaces/shares";
import store from "@/store";
import EventEmitter, { EmitterEvents } from "@/utils/eventEmitter";
import dayjs from "dayjs";
import { convertUTCTimeToLocalTime } from "@/utils/dateTimeUtils";
import { handleChecklistDataReportSplit } from "@/services/sharing";
import { Checklist } from "@/services/apiRoutes/routes";


export default /*#__PURE__*/_defineComponent({
  __name: 'incidentsAndEventsTable',
  props: {
  data: {
    type: Array as () => ICyberReportIncidents[],
    required: true,
    default: () => [],
  },
  isLoading: {
    type: Boolean,
    required: false,
  },
  isShowEdit: {
    type: Boolean,
    required: false,
    default: () => false,
  },
  columns: {
    type: Array,
    required: false,
    default: () => [
      "date",
      "event",
      "description",
      "impact",
      "cost",
      "notes",
      "actions",
    ],
  },
  isEdit: {
    type: Boolean,
    required: false,
    default: false,
  },
  isDiscard: {
    type: Boolean,
    required: false,
    default: false,
  },
},
  emits: [
  "edit-notes",
  "remove-item",
  "update-data",
  "call-api",
],
  setup(__props, { emit: emits }) {

const props = __props;



const defaultData = {
  addedByUserId: "",
  dateAdded: "",
  dateUpdated: "",
  incidentCost: "",
  incidentCostId: "",
  incidentDescription: "",
  incidentEndDate: "",
  incidentId: "",
  incidentImpactLevel: "",
  incidentImpactLevelId: "",
  incidentMitigations: "",
  incidentName: "",
  incidentNotes: "",
  incidentStartDate: "",
  incidentType: "",
  incidentTypeId: "",
  isArchived: false,
  updatedByUserId: "",
  hasChanged: false,
};

onMounted(() => {
  EventEmitter.on(EmitterEvents.SHARING_ADD_INCIDENT, () => {
    dataTable.value.push({
      ...defaultData,
      id: `${dayjs().unix()}-${Math.random().toString(36).substr(2, 9)}`,
    });
  });
});

const dataTable = ref([...props.data]);
const isLoadingTable = ref(props.isLoading);
const dataRemoveItem: any = ref([]);

watch(
  () => props.isLoading,
  (value) => {
    isLoadingTable.value = value;
  },
);



const checklistIncidentType = computed(
  () => store.getters["Sharing/getChecklistIncidentType"],
);

const impactDropdownData: any = computed(
  () => store.getters["Sharing/getChecklistImpactLevel"],
);

const costDropdownData: any = computed(
  () => store.getters["Sharing/getChecklistCost"],
);

const currentChecklistReportId = computed(
  () => store.getters["Sharing/getChecklistReportId"],
);

watch(
  () => props.isEdit,
  (value) => {
    if (!value && !props.isDiscard) {
      create();
      callRemoveItem();
    }
  },
);

const create = async () => {
  if (dataTable.value.length === 0) return;
  try {
    await dataTable.value.forEach(async (item) => {
      const cleanParams = Object.fromEntries(
        Object.entries({
          incidentTypeId: item.incidentTypeId,
          impactLevelId: item.incidentImpactLevelId
            ? item.incidentImpactLevelId
            : undefined,
          costId: item.incidentCostId ? item.incidentCostId : undefined,
          startDate: item.incidentStartDate,
          mitigations: item.incidentMitigations,
          description: item.incidentDescription,
        }).filter(([key, value]) => value !== "Invalid date"),
      );

      if (item.incidentId === "") {
        emits("call-api", true);
        Object.keys(cleanParams).forEach(
          (key) =>
            (cleanParams[key] === undefined || cleanParams[key] === "") &&
            delete cleanParams[key],
        );
        await store.dispatch("Sharing/postChecklistIncidents", cleanParams);
      } else if (item.hasChanged) {
        emits("call-api", true);
        await store.dispatch("Sharing/updateChecklistIncidents", {
          id: item.incidentId,
          option: cleanParams,
        });
      }
    });
    setTimeout(async () => {
      isLoadingTable.value = true;
      handleChecklistDataReportSplit(
        Checklist.getChecklistReportDataIncidents,
        currentChecklistReportId.value,
      );
      isLoadingTable.value = false;
    }, 500);
  } catch (error) {
    console.log("error", error);
  } finally {
    setTimeout(() => {
      emits("call-api", false);
    }, 1000);
  }
};

const callRemoveItem = async () => {
  await dataRemoveItem.value.forEach(async (item) => {
    if (item.incidentId) {
      await store.dispatch("Sharing/updateChecklistIncidents", {
        id: item.incidentId,
        option: {
          isArchived: true,
        },
      });
    }
  });
  dataRemoveItem.value = [];
};

const updateValue = (data, idDataTable, type) => {
  const index = dataTable.value.findIndex((item) => {
    if (item.incidentId === "") {
      return item.id === idDataTable.id;
    } else {
      return item.incidentId === idDataTable.incidentId;
    }
  });
  dataTable.value[index][type] = data;
  dataTable.value[index].hasChanged = true;
};

const hasChanged = (idDataTable) => {
  const index = dataTable.value.findIndex((item) => {
    if (item.incidentId === "") {
      return item.id === idDataTable.id;
    } else {
      return item.incidentId === idDataTable.incidentId;
    }
  });
  dataTable.value[index].hasChanged = true;
};

const getEventFormId = (id) => {
  return checklistIncidentType.value.find((item) => item.id === id)?.name;
};

const handleScoreSeclected = (event: IDropDownData, scoreType, idDataTable) => {
  const index = dataTable.value.findIndex((item) => {
    if (item.incidentId === "") {
      return item.id === idDataTable.id;
    } else {
      return item.incidentId === idDataTable.incidentId;
    }
  });

  const score = event.id
    ? scoreType === SCORE_TYPE.IMPACT
      ? CHECKLIST_IMPACT_VALUE_WITH_COLOR[`${event.id}`]
      : CHECKLIST_ICON_VALUE_WITH_COLOR[`${event.id}`]
    : "tw-text-[#231F20]";
  const bgScore = event.id
    ? scoreType === SCORE_TYPE.IMPACT
      ? CHECKLIST_IMPACT_VALUE_WITH_BG_COLOR[`${event.id}`]
      : CHECKLIST_ICON_VALUE_WITH_BG_COLOR[`${event.id}`]
    : "tw-bg-[rgba(72,160,255, 0.15)";
  switch (scoreType) {
    case SCORE_TYPE.IMPACT:
      dataTable.value[index].classImpactName = score;
      dataTable.value[index].bgImpactName = bgScore;
      dataTable.value[index].incidentImpactLevelId = event.id;
      break;
    case SCORE_TYPE.COST:
      dataTable.value[index].classCostName = score;
      dataTable.value[index].bgCostName = bgScore;
      dataTable.value[index].incidentCostId = event.id;
      break;
  }
  dataTable.value[index].hasChanged = true;
};

const getCostFormId = (id) => {
  return costDropdownData.value.find((item) => item.id === id)?.name;
};

const getImpactFormId = (id) => {
  return impactDropdownData.value.find((item) => item.id === id)?.name;
};

// format date to dd-mmm-yyyy
const formatDate = (date) => {
  return convertUTCTimeToLocalTime(date);
};

// format date to yyyy-mm-dd
const formatDateInput = (date) => {
  return dayjs(date).format("YYYY-MM-DD");
};
const processData = (data) => {
  const newVal = data || props.data;
  dataTable.value = newVal?.map((item) => {
    const scoreImpact = item.incidentImpactLevelId
      ? CHECKLIST_IMPACT_VALUE_WITH_COLOR[`${item.incidentImpactLevelId}`]
      : "tw-text-[#231F20]";
    const scoreCost = item.incidentCostId
      ? CHECKLIST_ICON_VALUE_WITH_COLOR[`${item.incidentCostId}`]
      : "tw-text-[#231F20]";
    const bgImpact = item.incidentImpactLevelId
      ? CHECKLIST_IMPACT_VALUE_WITH_BG_COLOR[`${item.incidentImpactLevelId}`]
      : "tw-text-[#231F20]";
    const bgCost = item.incidentCostId
      ? CHECKLIST_ICON_VALUE_WITH_BG_COLOR[`${item.incidentCostId}`]
      : "tw-text-[#231F20]";
    return {
      ...item,
      classImpactName: scoreImpact,
      classCostName: scoreCost,
      bgCostName: bgCost,
      bgImpactName: bgImpact,
      incidentStartDate: formatDateInput(item.incidentStartDate),
    };
  });
};

onMounted(() => {
  processData(dataTable.value);
});

watchEffect(() => {
  if (props.data) {
    processData([...props.data]);
  }
});

const removeItem = async (item) => {
  dataRemoveItem.value.push(item);
  dataTable.value = dataTable.value.filter((e: any) => {
    if (e.id) {
      return e.id !== item.id;
    } else {
      return e.incidentId !== item.incidentId;
    }
  });
};

const columnsTableFields = computed<CustomTableColumn[]>(() => {
  return [
    {
      text: getComponentUiText(
        "app-report-achievements-and-progress-table-date-header-title-1",
      ),
      value: "date",
      headerClass:
        "!tw-text-[#ffffff] tw-text-[10px] tw-font-semibold tw-tracking-[1px] tw-leading-[100%] tw-uppercase tw-w-[155px]",
      valueClass:
        "tw-text-[#231F20] tw-text-[13px] tw-font-medium tw-w-[155px]",
      sortable: false,
      sortDefault: false,
    },
    {
      text: getComponentUiText(
        "app-share-cyber-profile-incidents-and-events-table-event-header-title-1",
      ),
      value: "event",
      headerClass:
        "!tw-text-[#ffffff] tw-text-[10px] tw-font-semibold tw-tracking-[1px] tw-leading-[100%] tw-uppercase",
      valueClass: "tw-text-[#231F20] tw-text-[13px] tw-font-normal tw-w-[25%]",
    },
    {
      text: getComponentUiText(
        "app-share-cyber-profile-incidents-and-events-table-description-header-title-1",
      ),
      value: "description",
      headerClass:
        "!tw-text-[#ffffff] tw-text-[10px] tw-font-semibold tw-tracking-[1px] tw-leading-[100%] tw-uppercase",
      valueClass: "tw-text-[#231F20] tw-text-[13px] tw-font-normal tw-w-[20%]",
    },
    {
      text: getComponentUiText(
        "app-share-cyber-profile-incidents-and-events-table-impact-header-title-1",
      ),
      value: "impact",
      headerClass:
        "!tw-text-[#ffffff] tw-text-[10px] tw-font-semibold tw-tracking-[1px] tw-leading-[100%] tw-uppercase",
      valueClass: "tw-text-[#231F20] tw-text-[13px] tw-font-normal tw-w-[10%]",
    },
    {
      text: getComponentUiText(
        "app-share-cyber-profile-incidents-and-events-table-cost-header-title-1",
      ),
      value: "cost",
      headerClass:
        "!tw-text-[#ffffff] tw-text-[10px] tw-font-semibold tw-tracking-[1px] tw-leading-[100%] tw-uppercase",
      valueClass: "tw-text-[#231F20] tw-text-[13px] tw-font-normal tw-w-[10%]",
    },
    {
      text: getComponentUiText(
        "app-share-cyber-profile-incidents-and-events-table-mitigations-and-actions-header-title-1",
      ),
      value: "notes",
      headerClass:
        "!tw-text-[#ffffff] tw-text-[10px] tw-font-semibold tw-tracking-[1px] tw-leading-[100%] tw-uppercase",
      valueClass: "tw-text-[#231F20] tw-text-[13px] tw-font-normal tw-w-[20%]",
    },
    {
      text: "",
      value: "actions",
      valueClass:
        "tw-text-[#231F20] tw-text-[13px] tw-font-normal !tw-pl-[14px] !tw-pr-[23px]",
    },
  ].filter((item) => props.columns.includes(item.value));
});

return (_ctx: any,_cache: any) => {
  const _component_BFormInput = _resolveComponent("BFormInput")!

  return (_openBlock(), _createBlock(CustomTable, {
    columns: columnsTableFields.value,
    data: dataTable.value,
    "is-loading": isLoadingTable.value,
    "show-checkbox-row": false,
    "skeleton-row-number": 1,
    "sort-direction": 'asc',
    "custom-class": '!tw-shadow-none inciden-event-header',
    "header-wrapper-class": 'tw-py-[20px] tw-px-[25px]'
  }, _createSlots({
    "cell(date)": _withCtx((value) => [
      (!__props.isShowEdit)
        ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(value.item.incidentStartDate !== "Invalid date" &&
          value.item.incidentStartDate !== null &&
          value.item.incidentStartDate !== undefined
            ? formatDate(value.item.incidentStartDate)
            : ""), 1))
        : (_openBlock(), _createBlock(_component_BFormInput, {
            key: 1,
            id: "dateIncidenAndEventTable",
            modelValue: value.item.incidentStartDate,
            "onUpdate:modelValue": ($event: any) => ((value.item.incidentStartDate) = $event),
            value: value.item.incidentStartDate,
            class: "input-date-item",
            type: "date",
            placeholder: 
          _unref(getComponentUiText)(
            'app-scanning-schedule-modal-select-date-placeholder-1',
          )
        ,
            onInput: ($event: any) => (hasChanged(value.item))
          }, null, 8, ["modelValue", "onUpdate:modelValue", "value", "placeholder", "onInput"]))
    ]),
    "cell(event)": _withCtx((value) => [
      (!__props.isShowEdit)
        ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(getEventFormId(value.item.incidentTypeId)), 1))
        : (_openBlock(), _createBlock(BaseDropDown, {
            key: 1,
            id: 'eventIncidenAndEventTable',
            "model-value": value.item.incidentTypeId,
            data: checklistIncidentType.value,
            "class-name": 'gray-dropdown-container tw-h-[44px] is-inciden-event-table',
            "onUpdate:modelValue": 
          (valueItem) => updateValue(valueItem, value.item, 'incidentTypeId')
        
          }, null, 8, ["model-value", "data", "onUpdate:modelValue"]))
    ]),
    "cell(description)": _withCtx((value) => [
      _createElementVNode("div", _hoisted_3, [
        (!__props.isShowEdit)
          ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(value.item.incidentDescription), 1))
          : _withDirectives((_openBlock(), _createElementBlock("input", {
              key: 1,
              id: "input-rename",
              "onUpdate:modelValue": ($event: any) => ((value.item.incidentDescription) = $event),
              type: "text",
              class: "tw-border tw-border-solid tw-border-[#EFF0F1] tw-p-[12px] tw-pr-[45px] tw-text-[13px] tw-font-normal form-control notes-input-field",
              onKeyup: _withKeys(($event: any) => (hasChanged(value.item)), ["enter"]),
              onBlur: ($event: any) => (hasChanged(value.item))
            }, null, 40, _hoisted_5)), [
              [_vModelText, value.item.incidentDescription]
            ])
      ])
    ]),
    "cell(impact)": _withCtx((value) => [
      (!__props.isShowEdit)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("span", {
              class: _normalizeClass(`impact-cost-item ${value.item.classImpactName} ${value.item.bgImpactName}`)
            }, _toDisplayString(getImpactFormId(value.item.incidentImpactLevelId)), 3)
          ]))
        : (_openBlock(), _createBlock(BaseDropDown, {
            key: 1,
            id: 'impactIncidenAndEventTable',
            "model-value": value.item.incidentImpactLevelId,
            data: impactDropdownData.value,
            "class-name": `gray-dropdown-container tw-h-[44px] is-inciden-event-table`,
            "class-text-name": value.item.classImpactName
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(impactDropdownData.value, (item, index) => {
                return (_openBlock(), _createBlock(BaseDropDownItem, {
                  id: item.id.toString(),
                  key: index,
                  data: item,
                  text: item.name,
                  "class-name": `normal-dropdown-container ${
            item.id
              ? `${_unref(CHECKLIST_IMPACT_VALUE_WITH_COLOR)[`${item.id}`]}`
              : 'tw-text-[#231F20]'
          }`,
                  onClick: ($event: any) => (handleScoreSeclected(item, _unref(SCORE_TYPE).IMPACT, value.item))
                }, null, 8, ["id", "data", "text", "class-name", "onClick"]))
              }), 128))
            ]),
            _: 2
          }, 1032, ["model-value", "data", "class-text-name"]))
    ]),
    "cell(cost)": _withCtx((value) => [
      (!__props.isShowEdit)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("span", {
              class: _normalizeClass(`impact-cost-item ${value.item.classCostName} ${value.item.bgCostName}`)
            }, _toDisplayString(getCostFormId(value.item.incidentCostId)), 3)
          ]))
        : (_openBlock(), _createBlock(BaseDropDown, {
            key: 1,
            id: 'impactIncidenAndEventTable',
            "model-value": value.item.incidentCostId,
            data: costDropdownData.value,
            "class-name": `gray-dropdown-container tw-h-[44px] is-inciden-event-table`,
            "class-text-name": value.item.classCostName
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(costDropdownData.value, (item, index) => {
                return (_openBlock(), _createBlock(BaseDropDownItem, {
                  id: item.id.toString(),
                  key: index,
                  data: item,
                  text: item.name,
                  "class-name": `normal-dropdown-container ${
            item.id
              ? `${_unref(CHECKLIST_ICON_VALUE_WITH_COLOR)[`${item.id}`]}`
              : 'tw-text-[#231F20]'
          }`,
                  onClick: ($event: any) => (handleScoreSeclected(item, _unref(SCORE_TYPE).COST, value.item))
                }, null, 8, ["id", "data", "text", "class-name", "onClick"]))
              }), 128))
            ]),
            _: 2
          }, 1032, ["model-value", "data", "class-text-name"]))
    ]),
    "cell(notes)": _withCtx((value) => [
      _createElementVNode("div", _hoisted_8, [
        (!__props.isShowEdit)
          ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(value.item.incidentMitigations), 1))
          : _withDirectives((_openBlock(), _createElementBlock("input", {
              key: 1,
              "onUpdate:modelValue": ($event: any) => ((value.item.incidentMitigations) = $event),
              type: "text",
              class: "tw-border tw-border-solid tw-border-[#EFF0F1] tw-p-[12px] tw-pr-[45px] tw-text-[13px] tw-font-normal form-control notes-input-field",
              onKeyup: _withKeys(($event: any) => (hasChanged(value.item)), ["enter"]),
              onBlur: ($event: any) => (hasChanged(value.item))
            }, null, 40, _hoisted_10)), [
              [_vModelText, value.item.incidentMitigations]
            ])
      ])
    ]),
    _: 2
  }, [
    (__props.isShowEdit)
      ? {
          name: "cell(actions)",
          fn: _withCtx((value) => [
            _createElementVNode("div", {
              class: "tw-flex tw-justify-end tw-cursor-pointer",
              onClick: ($event: any) => (removeItem(value.item))
            }, _hoisted_13, 8, _hoisted_11)
          ]),
          key: "0"
        }
      : undefined
  ]), 1032, ["columns", "data", "is-loading"]))
}
}

})